class OpenAIModels {
  static models = [
    { label: 'GPT-4o', value: 'gpt-4o' },
    { label: 'GPT-5', value: 'gpt-5' },
  ]

  static getAll() {
    return this.models;
  }

  static getModelNameByValue(value) {
    const found = this.models.find((m) => m.value === value);
    return found ? found.label : '';
  }

  static getDefault() {
    return 'gpt-4o';
  }
} 

export default OpenAIModels;
